import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  operations as siteOperations,
  selectors as siteSelectors,
  actions as siteActions,
} from 'store/siteManager'
import { Formik } from 'formik'
import { validationSchema, fieldNames } from './data'

import ProgramStartDateModalComponent from './component'

export const ProgramStartDateModalContainer = ({
  clearError,
  flowLabel,
  hasApiError,
  handleClose,
  modals,
  site,
  programStartDate,
  programStartDateIsComplete,
  updateSitePreferences,
}) => {
  const [currentStep, setCurrentStep] = useState(
    programStartDateIsComplete ? 1 : 0,
  )

  const handleStepChange = toStep => setCurrentStep(toStep)
  const goBack = () => {
    handleStepChange(currentStep - 1)
  }

  const handleSave = async values => {
    const newSitePreferences = {
      k5Digital: {
        programStartDate: values.programStartDate,
        programStartDateIsCompleted: true,
      },
      mspDigital: {
        programStartDate: values.programStartDate,
        programStartDateIsCompleted: true,
      },
    }
    await updateSitePreferences(site.id, newSitePreferences)
  }

  const closeModal = () => {
    clearError('sitePreferences')
    handleClose()
  }

  const initialValues = {
    programStartDate: programStartDate ? new Date(programStartDate) : null,
  }

  return (
    <Formik
      initialTouched={{
        programStartDate: !!programStartDate,
      }}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        setSubmitting,
        setTouched,
        isSubmitting,
        isValid,
      }) => (
        <ProgramStartDateModalComponent
          currentStep={currentStep}
          errors={errors}
          flowLabel={flowLabel}
          goBack={() => goBack()}
          handleChange={(name, value) => {
            setFieldTouched(name)
            setFieldValue(name, value)
          }}
          handleClose={closeModal}
          handleNextButtonClick={async () => {
            const isValidSync = validationSchema.isValidSync(values)
            if (!isValidSync) {
              const touchedFields = fieldNames.reduce((acc, name) => {
                acc[name] = true
                return acc
              }, {})
              await setTouched(touchedFields)
              return
            }
            setSubmitting(true)
            await handleSave(values)
            setSubmitting(false)
            closeModal()
          }}
          hasApiError={hasApiError}
          isSubmitting={isSubmitting}
          isValid={isValid}
          modals={modals}
          touched={touched}
          values={values}
        />
      )}
    </Formik>
  )
}

const mapStateToProps = (state, ownProps) => {
  const site = siteSelectors?.selectSiteById(state, ownProps.siteId)
  const { sitePreferences = {} } = site || {}
  const { k5Digital = {} } = sitePreferences
  const { programStartDate, programStartDateIsComplete } = k5Digital
  const { sitePreferences: sitePreferencesAPIResults } = state.siteManager
  const { error } = sitePreferencesAPIResults

  return {
    hasApiError: !!error,
    site,
    programStartDate,
    programStartDateIsComplete,
  }
}

const mapDispatchToProps = {
  updateSitePreferences: siteOperations.updateSitePreferences,
  clearError: siteActions.clearError,
}

ProgramStartDateModalContainer.propTypes = {
  clearError: PropTypes.func,
  dispatch: PropTypes.func,
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func,
  hasApiError: PropTypes.bool,
  modals: PropTypes.array,
  programStartDate: PropTypes.string,
  programStartDateIsComplete: PropTypes.bool,
  site: PropTypes.shape({
    id: PropTypes.number,
    sitePreferences: PropTypes.object,
  }),
  updateSitePreferences: PropTypes.func,
}

const mapper = entry => {
  const { modals, flowLabel } = entry || {}

  return {
    modals,
    flowLabel,
  }
}

const options = {
  entryId: '1quGZvQXMzNKK341sijHx0',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    ProgramStartDateModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
